import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../../Components/Breadcrumb/Breadcrumb'
import EvnVar from '../../../EnvVar';
import Cookies from 'js-cookie';
import axios from 'axios';

const baseURL = EvnVar()

function Testimonials() {
    const [testimonials, setTestimonials] = useState([])
    useEffect(() => {
        const token = Cookies.get("jwt");
        let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `${baseURL}/dash/testimonials`,
            headers: {
                Authorization: token,
            },
            withCredentials: true,
        };

        axios
            .request(config)
            .then((response) => {
                let result = JSON.stringify(response.data);
                let data = JSON.parse(result);
                setTestimonials(data);
                // console.log("Testimonial Data", data);
            })
            .catch((error) => {
                console.log("Error fetching data:", error);
            });
    }, []);
    return (
        <>
            <Breadcrumb data="Testimonials" />
            <div className="content-body">
                <div className="table-data">
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th style={{width: "30%"}}>Date</th>
                                    <th style={{width: "15%"}}>Survey ID</th>
                                    <th>Testimonial</th>
                                </tr>
                            </thead>
                            <tbody>
                                {testimonials && testimonials.map((value, index) => {
                                    const isoDateString = value.created_at;
                                    const date = new Date(isoDateString);

                                    const options = {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric',
                                        hour: 'numeric',
                                        minute: 'numeric',
                                        second: 'numeric',
                                        hour12: true
                                    };

                                    const formattedDateTime = date.toLocaleString(undefined, options);
                                    return (
                                        <tr key={index}>
                                            <td>{formattedDateTime}</td>
                                            <td>{value.survey_id}</td>
                                            <td>{value.testimonial_text}</td>
                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Testimonials
